import { QualifiedStatus, TradeDetailStatus } from '@revenuemarket/trade';

import { ResponseBase } from '~types/response';

import { API } from './axios/instance';

export interface MetaResponse extends ResponseBase {
  data: {
    user: {
      /** 유저 id */
      userId: string;
      /** email */
      email: string;
      /** 유저 이름 */
      name: string;
      /** 유저 역할 */
      position: string;
    };
    company: {
      /** 회사 id */
      companyId: string;
      /** trade 갯수 */
      numOfTrades: number;
      /** trade 상태 */
      tradeStatus: TradeDetailStatus;
      /** 계좌 갯수 */
      numOfCheckingAccounts: number;
      /** 은행 갯수 */
      numOfBanks: number;
      /** 인증서 갯수 */
      numOfCertificates: number;
      /** data qualification data */
      dataQualifications: {
        /** 매출 */
        revenue: QualifiedStatus;
        /** 은행 */
        bank: QualifiedStatus;
      };
    };
  };
}
/**
 * meta api response
 * @link https://apollo11.dev.clobe.ai/swagger-ui/index.hgtml#/bi-metadata-controller/getMetadata
 * @param companyId 회사 id
 * @param userId user id
 * @returns
 */
export const getMetaData = (companyId: string, userId: string, accessToken?: string) => {
  const token = accessToken
    ? {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    : {};
  return API.get<MetaResponse>(`/api/v2/companies/${companyId}/users/${userId}/bi/metadata`, {
    ...token,
  });
};
